import { AxiosResponse, AxiosError } from 'axios';

// Constants
import {
    TIMESHEETS_LOAD_REQUESTED,
    TIMESHEETS_LOAD_SUCCEEDED,
    TIMESHEETS_LOAD_FAILED,
    TIMESHEETS_LOAD_CANCELED,
    TIMESHEET_APPROVE_REQUESTED,
    TIMESHEET_APPROVE_SUCCEEDED,
    TIMESHEET_APPROVE_FAILED,
    TIMESHEET_SUBMIT_REQUESTED,
    TIMESHEET_SUBMIT_SUCCEEDED,
    TIMESHEET_SUBMIT_FAILED,
    TIMESHEET_DELETE_REQUESTED,
    TIMESHEET_DELETE_SUCCEEDED,
    TIMESHEET_DELETE_FAILED,
    TIMESHEETS_SET,
    TIMESHEET_MULTIPLE_SUBMIT_SUCCEEDED,
    TIMESHEET_MULTIPLE_SUBMIT_FAILED,
    TIMESHEET_MULTIPLE_SUBMIT_REQUESTED,
    DATAPAY_HOLIDAY_DAYS_EXPORT_REQUESTED,
    DATAPAY_HOLIDAY_DAYS_EXPORT_SUCCEEDED,
    DATAPAY_HOLIDAY_DAYS_EXPORT_FAILED,
    TIMESHEET_UNAPPROVE_FAILED,
    TIMESHEET_UNAPPROVE_REQUESTED,
    TIMESHEET_UNAPPROVE_SUCCEEDED
} from './constants';

import {
    RequestLoadTimesheetsAction,
    SucceededLoadTimesheetsAction,
    FailedLoadTimesheetsAction,
    CanceledLoadTimesheetsAction,
    RequestApproveTimesheetAction,
    SucceededApproveTimesheetAction,
    FailedApproveTimesheetAction,
    RequestSubmitTimesheetAction,
    SucceededSubmitTimesheetAction,
    FailedSubmitTimesheetAction,
    RequestDeleteTimesheetAction,
    SucceededDeleteTimesheetAction,
    SetTimesheetsAction,
    FailedDeleteTimesheetAction,
    SucceededSubmitMultipleTimesheetsAction,
    FailedSubmitMultipleTimesheetsAction,
    RequestSubmitMultipleTimesheetsAction,
    RequestDatapayHolidayDaysAction,
    SucceededDatapayHolidayDaysAction,
    FailedDatapayHolidayDaysAction,
    FailedUnapproveTimesheetAction,
    RequestUnapproveTimesheetAction,
    SucceededUnapproveTimesheetAction
} from './types';

export function requestLoadTimesheets(): RequestLoadTimesheetsAction {
    return {
        type: TIMESHEETS_LOAD_REQUESTED
    };
}

export function succeededLoadTimesheets(
    response: Record<string, any>
): SucceededLoadTimesheetsAction {
    return {
        type: TIMESHEETS_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadTimesheets(error: Error): FailedLoadTimesheetsAction {
    return {
        type: TIMESHEETS_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function canceledLoadTimesheets(): CanceledLoadTimesheetsAction {
    return {
        type: TIMESHEETS_LOAD_CANCELED
    };
}

export function requestApproveTimesheet(
    timesheetId: number
): RequestApproveTimesheetAction {
    return {
        type: TIMESHEET_APPROVE_REQUESTED,
        payload: {
            timesheetId
        }
    };
}

export function succeededApproveTimesheet(
    responses: Record<string, any>
): SucceededApproveTimesheetAction {
    return {
        type: TIMESHEET_APPROVE_SUCCEEDED,
        payload: responses
    };
}

export function failedApproveTimesheet(
    error: Error
): FailedApproveTimesheetAction {
    return {
        type: TIMESHEET_APPROVE_FAILED,
        payload: error,
        error: true
    };
}

export function requestUnapproveTimesheet(
    timesheetId: number
): RequestUnapproveTimesheetAction {
    return {
        type: TIMESHEET_UNAPPROVE_REQUESTED,
        payload: {
            timesheetId
        }
    };
}

export function succeededUnapproveTimesheet(
    response: Record<string, any>
): SucceededUnapproveTimesheetAction {
    return {
        type: TIMESHEET_UNAPPROVE_SUCCEEDED,
        payload: response
    };
}

export function failedUnapproveTimesheet(
    error: Error
): FailedUnapproveTimesheetAction {
    return {
        type: TIMESHEET_UNAPPROVE_FAILED,
        payload: error,
        error: true
    };
}

export function requestSubmitMultipleTimesheets(
    timesheetIds: number[]
): RequestSubmitMultipleTimesheetsAction {
    return {
        type: TIMESHEET_MULTIPLE_SUBMIT_REQUESTED,
        payload: {
            timesheetIds
        }
    };
}

export function succeededSubmitMultipleTimesheets(
    responses: Record<string, any>
): SucceededSubmitMultipleTimesheetsAction {
    return {
        type: TIMESHEET_MULTIPLE_SUBMIT_SUCCEEDED,
        payload: responses
    };
}

export function failedSubmitMultipleTimesheets(
    error: Error
): FailedSubmitMultipleTimesheetsAction {
    return {
        type: TIMESHEET_MULTIPLE_SUBMIT_FAILED,
        payload: error,
        error: true
    };
}

export function requestSubmitTimesheet(
    timesheetId: number
): RequestSubmitTimesheetAction {
    return {
        type: TIMESHEET_SUBMIT_REQUESTED,
        payload: {
            timesheetId
        }
    };
}

export function succeededSubmitTimesheet(
    responses: Record<string, any>
): SucceededSubmitTimesheetAction {
    return {
        type: TIMESHEET_SUBMIT_SUCCEEDED,
        payload: responses
    };
}

export function failedSubmitTimesheet(
    error: Error
): FailedSubmitTimesheetAction {
    return {
        type: TIMESHEET_SUBMIT_FAILED,
        payload: error,
        error: true
    };
}

export function requestDeleteTimesheet(
    timesheetId: number
): RequestDeleteTimesheetAction {
    return {
        type: TIMESHEET_DELETE_REQUESTED,
        payload: {
            timesheetId
        }
    };
}

export function succeededDeleteTimesheet(
    response: Record<string, any>
): SucceededDeleteTimesheetAction {
    return {
        type: TIMESHEET_DELETE_SUCCEEDED,
        payload: response
    };
}

export function failedDeleteTimesheet(
    error: Error
): FailedDeleteTimesheetAction {
    return {
        type: TIMESHEET_DELETE_FAILED,
        payload: error,
        error: true
    };
}

export function setTimesheets(data: {
    [key: string]: Record<string, any>;
}): SetTimesheetsAction {
    return {
        type: TIMESHEETS_SET,
        payload: data
    };
}

export function requestExportDatapayHolidayDays(): RequestDatapayHolidayDaysAction {
    return {
        type: DATAPAY_HOLIDAY_DAYS_EXPORT_REQUESTED
    };
}

export function succeededExportDatapayHolidayDays(
    response: AxiosResponse
): SucceededDatapayHolidayDaysAction {
    return {
        type: DATAPAY_HOLIDAY_DAYS_EXPORT_SUCCEEDED,
        payload: response
    };
}

export function failedExportDatapayHolidayDays(
    error: AxiosError
): FailedDatapayHolidayDaysAction {
    return {
        type: DATAPAY_HOLIDAY_DAYS_EXPORT_FAILED,
        payload: error,
        error: true
    };
}
